const menuActionTypes = {
    toggleMenuVisible: 'TOGGLE_MENU_VISIBLE',
    setSort: 'SET_SORT',
    setSubmenuCategory: 'SET_SUBMENU_CATEGORY'
};

export default menuActionTypes;